// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__25fZG","buttons":"SendReceipts_buttons__3_2EL","email":"SendReceipts_email__3vGV7","bookApptTitle":"SendReceipts_bookApptTitle__7RPoR"};